// library
import React from 'react';
// internal
// components

export default function HandIcon({
  width,
  height,
  fill,
  additionalStyles,
  isHandDown,
}) {
  const style = {
    width: `${width}px`,
    height: `${height}px`,
    ...additionalStyles,
  };
  const viewBox = `0 0 ${24} ${24}`;
  return (
    <svg style={style} viewBox={viewBox} className="hand-icon">
      <path
        fill={fill}
        d="M22.685 6.5908C21.8731 6.53286 21.0601 7.23167 20.8283 8.10666L19.32 12.4792C18.914 13.2371 18.334 12.5962 18.3916 12.2462C18.4493 11.8962 19.6106 3.55903 19.6106 3.55903C19.7847 2.68405 19.6682 1.81024 18.7988 1.63522C17.9281 1.46022 17.2904 2.10111 17.1163 2.97609C17.1163 2.97609 15.8973 10.7894 15.5502 11.5474C15.202 12.3053 14.8537 12.0724 14.8537 11.4894C14.8537 11.1394 15.4338 1.75215 15.4338 1.75215C15.4914 0.877165 15.1431 0.0612972 14.2736 0.00336037C13.403 -0.0545795 12.997 0.644237 12.9394 1.51922C12.9394 1.51922 12.0687 10.6735 12.0111 11.3143C11.9534 11.9552 11.3734 12.0143 11.2569 11.3143C11.1404 10.6143 10.7933 3.15199 10.7933 3.15199C10.7933 2.277 10.3874 1.51907 9.51672 1.51907C8.64606 1.51907 8.24013 2.277 8.24013 3.15199C8.24013 3.15199 8.18248 10.7903 8.24013 12.1891C8.29778 13.705 8.35661 17.4945 7.36947 17.6117C6.44116 17.7287 4.99044 16.6208 4.17851 15.3958C3.48197 14.405 2.2642 13.7629 0.98755 13.9379C-0.869103 14.1708 0.233365 15.6287 1.50996 17.0288C4.23727 20.0026 4.93254 21.5762 6.26808 23.5592C7.13875 24.9001 9.16953 27.0581 12.8816 26.9988C17.8714 26.9409 20.6563 24.9579 21.2943 16.3286C21.4107 14.4048 22.8603 8.34006 23.0933 7.64143C23.2062 7.52318 23.1486 6.59024 22.685 6.59024V6.5908Z"
      />
    </svg>
  );
}

//
